import styles from './KeyTicketDetails.module.css'
import MeterBar from './MeterBar'
import Avatar from './Avatar'
import Icon from './Icon'

// Higher-is-better meters (CSAT, Resolution Quality): green high, amber mid, red low.
function qualityTone(v) {
  if (typeof v !== 'number') return 'info'
  if (v >= 68) return 'good'
  if (v >= 40) return 'warn'
  return 'bad'
}

// Friction is higher-is-worse: green low, amber elevated, red severe.
function frictionTone(v) {
  if (typeof v !== 'number') return 'info'
  if (v >= 90) return 'bad'
  if (v >= 50) return 'warn'
  return 'good'
}

/**
 * KeyTicketDetails — the case detail right-rail panel: complexity, who created the
 * case, its categories, and the CSAT / Resolution Quality / Ownership Friction meters.
 *
 * Props: complexity, createdBy, categories[], csat, resolutionQuality,
 *        resolutionQualityCaption, friction, frictionCaption.
 */
export default function KeyTicketDetails({
  customer, complexity, createdBy, categories = [],
  csat, resolutionQuality, resolutionQualityCaption,
  friction, frictionCaption,
}) {
  return (
    <section className={styles.panel}>
      <h2 className={styles.heading}>Key Ticket Details</h2>

      <div className={styles.block}>
        <span className={styles.rowLabel}><BuildingIcon /> Customer</span>
        {customer
          ? <span className={styles.createdBy}>{customer}</span>
          : <span className={styles.muted}>—</span>}
      </div>

      <div className={styles.block}>
        <span className={styles.rowLabel}><UserIcon /> Created by</span>
        {createdBy
          ? <span className={styles.createdBy}><Avatar name={createdBy} size={24} /> {createdBy}</span>
          : <span className={styles.muted}>—</span>}
      </div>

      <div className={styles.block}>
        <span className={styles.rowLabel}><TagIcon /> Categories</span>
        <div className={styles.chips}>
          {categories.length > 0
            ? categories.map((c, i) => <span key={i} className={styles.categoryChip}>{c}</span>)
            : <span className={styles.muted}>—</span>}
        </div>
      </div>

      <div className={styles.block}>
        <span className={styles.rowLabel}><ComplexityIcon /> Complexity</span>
        <span className={styles.complexityChip}>{complexity || '—'}</span>
      </div>

      <div className={styles.meters}>
        <MeterBar label="CSAT" value={csat} tone={qualityTone(csat)} icon={<ThumbIcon />} />
        <MeterBar
          label="Resolution Quality"
          value={resolutionQuality}
          caption={resolutionQualityCaption}
          tone={qualityTone(resolutionQuality)}
          icon={<ChartIcon />}
        />
        <MeterBar
          label="Ownership Friction"
          value={friction}
          caption={frictionCaption}
          tone={frictionTone(friction)}
          icon={<FrictionIcon />}
        />
      </div>
    </section>
  )
}

function ComplexityIcon() {
  return <Icon name="complexity" />
}

function BuildingIcon() {
  return <Icon name="globe" />
}

function UserIcon() {
  return <Icon name="user" />
}

function TagIcon() {
  return <Icon name="tag" />
}

function ThumbIcon() {
  return <Icon name="thumb" />
}

function ChartIcon() {
  return <Icon name="analytics" />
}

function FrictionIcon() {
  return <Icon name="friction" />
}
